"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _configureFileManager = _interopRequireDefault(require("FileManagerLib/components/configureFileManager"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _default = (0, _configureFileManager.default)({
  httpClient: _apiClient.default,
  usageTracker: _eventsTrackerUtils.tracker,
  withDragDropContext: false
});

exports.default = _default;
module.exports = exports.default;